@if (vm$ | async; as vm) {
  <div class="uw-dialog-header">
    @if (!form.value.suggestAmountId) {
      <h1 class="uw-dialog-heading">{{ "common.add_suggested_amount" | translate }}</h1>
    }
    @if (form.value.suggestAmountId) {
      <h1 class="uw-dialog-heading">{{ "common.update_suggested_amount" | translate }}</h1>
    }
    <button [attr.aria-label]="'aria.close' | translate" cdkFocusInitial mat-icon-button mat-dialog-close>
      <mat-icon>
        close
      </mat-icon>
    </button>
  </div>
  <div class="uw-dialog-content">
    @if (errorMessage) {
      <div class="error-container">
        {{this.errorMessage }}
      </div>
    }
    <div [formGroup]="form" class="suggested-amount-detail__form">
      <div>
        <div class="uw-field">
          <label for="lowerRangeAmount" class="uw-label">
            {{ "common.last_year_gift_greater_than" | translate }}
          </label>
          <input id="lowerRangeAmount" type="number" formControlName="lowerRangeAmount" class="uw-input">
        </div>
        <div class="uw-field">
          <label for="upperRangeAmount" class="uw-label">
            {{ "common.last_year_gift_less_than_or_equal_to" | translate }}
          </label>
          <input id="upperRangeAmount" type="number" formControlName="upperRangeAmount" class="uw-input">
        </div>
        <div class="uw-field">
          <label for="suggestedAmountType" class="uw-label">
            {{ "common.suggested_amount_type" | translate }}
          </label>
          <select id="suggestedAmountType" class="uw-select" formControlName="suggestedAmountType">
            @for (suggestedAmountType of suggestedAmountTypes; track suggestedAmountType) {
              <option [value]="suggestedAmountType.value">
                {{ "common." + suggestedAmountType.name | translate }}
              </option>
            }
          </select>
        </div>
        <!-- <div class="uw-field">
        <mat-checkbox class="uw-checkbox" formControlName="showMessageOnly">
          {{ "common.show_message_only" | translate }}
        </mat-checkbox>
      </div> -->
      @if (languages) {
        <div class="uw-field">
          <label for="languageCode" class="uw-label">
            {{ "common.language" | translate }}
          </label>
          <select id="languageCode" class="uw-select" formControlName="languageCode" >
            <!-- <option value="" selected disabled>{{ "common.select" | translate }}</option> -->
            @for (lang of languages; track lang) {
              <option [value]="lang.key">{{lang.value}}</option>
            }
          </select>
        </div>
      }
    </div>
    <div>
      <div class="uw-field">
        <label for="firstAmount" class="uw-label">
          {{ "common.suggested_amount" | translate }} ({{ "common.first" | translate }})
        </label>
        <input id="firstAmount" type="number" formControlName="firstAmount" class="uw-input">
      </div>
      <div class="uw-field">
        <label for="secondAmount" class="uw-label">
          {{ "common.suggested_amount" | translate }} ({{ "common.second" | translate }})
        </label>
        <input id="secondAmount" type="number" formControlName="secondAmount" class="uw-input">
      </div>
      <div class="uw-field">
        <label for="thirdAmount" class="uw-label">
          {{ "common.suggested_amount" | translate }} ({{ "common.third" | translate }})
        </label>
        <input id="thirdAmount" type="number" formControlName="thirdAmount" class="uw-input">
      </div>
    </div>
    <div>
      <div class="uw-field suggest-amount-detail__message">
        <label for="message" class="uw-label">
          {{ "common.message" | translate }}
        </label>
        <textarea id="message" type="text" formControlName="message" class="uw-textarea"></textarea>
      </div>
    </div>
  </div>
</div>
<div class="uw-dialog-footer">
  <div class="uw-actions">
    <button class="uw-stroked-button" mat-dialog-close>
      {{ "buttons.cancel" | translate }}
    </button>
    @if (form.value.suggestAmountId) {
      <button class="uw-default-button" (click)="onSave(form.value)">
        {{ "buttons.save" | translate }}
      </button>
    }
    @if (!form.value.suggestAmountId) {
      <button class="uw-default-button" (click)="onSave(form.value)" [disabled]="form.pristine || !form.valid">
        {{ "buttons.create" | translate }}
      </button>
    }
  </div>
</div>
}
